<div class="top-row">
    <div class="user-add">
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input [formControl]="mailUser" matInput placeholder="user@gmail.com">
        </mat-form-field>
        <button (click)="addUser()" mat-button>Добавить</button>
    </div>
    <mat-form-field>
        <mat-label>Поиск</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search">
    </mat-form-field>
</div>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let element; let i = index;">{{i+1}}</td>
    </ng-container>
  
  
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef> Имя </th>
      <td mat-cell *matCellDef="let element"> {{element.username}} </td>
    </ng-container>
  
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Почта </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>
    <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef> Роль </th>
        <td mat-cell *matCellDef="let element"> 
            <div *ngIf="element.role == 4 or element.role == 5; else noAdmin">
                Администратор группы
            </div>
            <ng-template #noAdmin>
                <mat-select [(value)]="element.role">
                    <mat-option *ngFor="let role of roles" (click)="changeRole(element.id, role.id)" [value]="role.id">
                      {{role.subname}}
                    </mat-option>
                </mat-select>
            </ng-template>
        </td>
      </ng-container>

    <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef> Удалить </th>
        <td mat-cell *matCellDef="let element; let i=index;">
            <ng-container *ngIf="element.role !== 4">
                <button color="warn" (click)="deleteUser(element.id, i)" mat-mini-fab >
                    <mat-icon >close</mat-icon>
                </button>
            </ng-container>
        </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; let i=index"></tr>
</table>